// services/SemesterService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getSemesters(params = {}) {
    return api.get(ENDPOINTS.SEMESTERS.BASE, { params });
}
export function getSemesterById(id) {
    return api.get(ENDPOINTS.SEMESTERS.BY_ID(id));
}
export function createSemester(payload) {
    return api.post(ENDPOINTS.SEMESTERS.BASE, payload);
}
export function updateSemester(id, payload) {
    return api.patch(ENDPOINTS.SEMESTERS.BY_ID(id), payload);
}
export function deleteSemester(id) {
    return api.delete(ENDPOINTS.SEMESTERS.BY_ID(id));
}
export function restoreSemester(id) {
    return api.post(`${ENDPOINTS.SEMESTERS.BY_ID(id)}/restore`);
}
